import React from 'react';
import { withTranslation } from 'react-i18next';

const EditForm = ({ submit, cancel, children, t }) => {
    return (
        <div className="form_container">
            <div className='form-class'>
                {children}
                <div className="form-buttons-container">
                    <button onClick={submit}>{t("Table.saveButton")}</button>
                    <button onClick={cancel}>{t("Table.cancelButton")}</button>
                </div>
            </div>
        </div>
    )
}

export default withTranslation("translations")(EditForm)